import { render, staticRenderFns } from "./viewpending.vue?vue&type=template&id=179455c4&scoped=true&"
import script from "./viewpending.vue?vue&type=script&lang=js&"
export * from "./viewpending.vue?vue&type=script&lang=js&"
import style0 from "./viewpending.vue?vue&type=style&index=0&id=179455c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179455c4",
  null
  
)

export default component.exports